import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import { FiExternalLink } from "react-icons/fi"
import styled from "@emotion/styled"

const Styles = styled.div`
padding: 84px 0px;
  min-height: 100vh;

  ul {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .my-external {
    margin-left: 4px;
    font-size: 10px;
    position: relative;
    bottom: 2px;
  }
`

export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    return (
      <Layout path="program">
        <SEO title="Program" />
        <Styles>
          <Container>
            <div className="title" style={{ marginBottom: 36 }}>
              Program
            </div>

            <div className="title is-4">Step 0</div>
            <div className="subtitle" style={{ marginBottom: 0 }}>
              Steps start with 0 now
            </div>

            <div className="content">
              <ul>
                <li>
                  Create a{" "}
                  <a
                    href="https://github.com/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Github
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  account.
                </li>
              </ul>
            </div>

            <div className="title is-4">Step 1</div>

            <div className="subtitle" style={{ marginBottom: 0 }}>
              You'll need a text editor
            </div>

            <div className="content">
              <ul>
                <li>
                  <a
                    href="https://code.visualstudio.com/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    VSCode
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  (Installed locally)
                </li>

                <li>
                  <a
                    href="http://brackets.io/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Brackets
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  (Installed locally)
                </li>

                <li>
                  <a
                    href="https://gitpod.io"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Gitpod
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  (Cloud-based) $
                </li>

                <li>
                  <a
                    href="https://codeanywhere.com/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    CodeAnywhere
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  (Cloud-based) $
                </li>

                <li>
                  <a
                    href="https://codesandbox.io/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    CodeSandbox
                    <FiExternalLink className="my-external" />
                  </a>{" "}
                  (Cloud-based)
                </li>
              </ul>
            </div>

            <div className="title is-4">Step 2</div>

            <div className="subtitle" style={{ marginBottom: 0 }}>
              Learn HTML, CSS, JavaScript
            </div>

            <div className="content">
              <ul>
                <li>
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/HTML"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    HTML
                    <FiExternalLink className="my-external" />
                  </a>
                </li>

                <li>
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/css"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CSS
                    <FiExternalLink className="my-external" />
                  </a>
                </li>

                <li>
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/javascript"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    JavaScript
                    <FiExternalLink className="my-external" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://freecodecamp.org/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Free Code Camp
                    <FiExternalLink className="my-external" />
                  </a>
                </li>

                <li>
                  <a
                    href="https://github.com/samullman/starter"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Starter
                    <FiExternalLink className="my-external" />
                  </a>
                </li>

                <li>
                  <a
                    href="https://freecodecamp.org/"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    CodeWars
                    <FiExternalLink className="my-external" />
                  </a>
                </li>
              </ul>
            </div>

            <div className="title is-4">Step 3</div>
            <div className="subtitle" style={{ marginBottom: 0 }}>
              Gatsby 🚀
            </div>

            <div className="content">
              <ul>
                <li>
                  <a
                    href="https://github.com/greybirdtech/gatsby-starter"
                    target="_blank"
                    ref="noreopener noreferrer"
                  >
                    Gatsby Starter
                  </a>
                </li>
              </ul>
            </div>

            <div className="title is-4">Step 4</div>
            <div className="subtitle" style={{ marginBottom: 0 }}>
              Graduate.
            </div>
            <div className="content">

            </div>

            <div className="title is-4">Step 5</div>
            <div className="subtitle" style={{ marginBottom: 0 }}>
              Network.
            </div>

            <div className="content">
              <ul>
                <li>
                  <a href="https://gatsbytemplates.io/" target="_blank" rel="noopener noreferrer">Templates</a>
                </li>

                <li>
                  <Link to="/projects">Projects</Link>
                  
                </li>

                <li>
                  <Link to="/snippets">Snippets</Link>.
                </li>

                <li>
                  <Link to="/courses">Courses</Link>.
                </li>

                <li>
                  <Link to="/jobs">Jobs</Link>.
                </li>
              </ul>
            </div>
          </Container>
        </Styles>
      </Layout>
    )
  }
}
